import { formatReportAmount } from './userStatisticsReportConstants';
import { MEMBER_ROLE_OPTIONS } from '../members/memberConstants';

export const PERSONAL_DATA_PAGE_SIZE = 10;

export const PERSONAL_DATA_ROLE_OPTIONS = MEMBER_ROLE_OPTIONS;

export const REFRESH_INTERVAL_MS = 5 * 60 * 1000;

export function buildPersonalDataPageParams(pageNo, filters = {}, pageSize = PERSONAL_DATA_PAGE_SIZE) {
  const params = {
    pageNo,
    pageSize,
  };
  if (filters.roleId) {
    params.roleId = Number(filters.roleId);
  }
  if (filters.topInviterId?.trim()) {
    params.topInviterId = Number(filters.topInviterId.trim());
  }
  if (filters.inviterId?.trim()) {
    params.inviterId = Number(filters.inviterId.trim());
  }
  if (filters.memberId?.trim()) {
    params.memberId = Number(filters.memberId.trim());
  }
  if (filters.totalBalanceMin?.trim()) {
    params.totalBalanceMin = filters.totalBalanceMin.trim();
  }
  if (filters.totalBalanceMax?.trim()) {
    params.totalBalanceMax = filters.totalBalanceMax.trim();
  }
  if (filters.totalOrderPriceMin?.trim()) {
    params.totalOrderPriceMin = filters.totalOrderPriceMin.trim();
  }
  if (filters.totalOrderPriceMax?.trim()) {
    params.totalOrderPriceMax = filters.totalOrderPriceMax.trim();
  }
  if (filters.totalDepositMin?.trim()) {
    params.totalDepositMin = filters.totalDepositMin.trim();
  }
  if (filters.totalDepositMax?.trim()) {
    params.totalDepositMax = filters.totalDepositMax.trim();
  }
  if (filters.noDepositDay?.trim()) {
    params.noDepositDay = Number(filters.noDepositDay.trim());
  }
  if (filters.noLoginDay?.trim()) {
    params.noLoginDay = Number(filters.noLoginDay.trim());
  }
  return params;
}

export function buildPersonalDataExportParams(filters = {}, exportCurrentPageOnly, pageNo) {
  const params = buildPersonalDataPageParams(pageNo || 1, filters, PERSONAL_DATA_PAGE_SIZE);
  params.exportCurrentPageOnly = exportCurrentPageOnly;
  params.fileName = 'member_personal_statistical';
  return params;
}

export function formatDateTime(value) {
  if (!value) {
    return '—';
  }
  return String(value).replace('T', ' ').slice(0, 19);
}

export { formatReportAmount };
